var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12440",
    "data-name": "Path 12440",
    d: "M-360.054,2007.694q.121.008.242.021a5.91,5.91,0,0,1,.9.171q.312.083.614.2a6.329,6.329,0,0,1,.619.268,5.607,5.607,0,0,1,.571.328,5.363,5.363,0,0,1,.522.387,5.387,5.387,0,0,1,.471.448,5.481,5.481,0,0,1,.418.509,5.78,5.78,0,0,1,.365.57q.078.14.149.283a5.337,5.337,0,0,1-.451,5.692c-.092.137-.2.262-.315.4.033.035.067.071.1.106l3.286,3.3a.732.732,0,0,1,.156.957.773.773,0,0,1-1.13.179,2.067,2.067,0,0,1-.153-.142l-3.286-3.3a.665.665,0,0,1-.068-.089c-.374.19-.708.39-1.066.536a5.823,5.823,0,0,1-4.779-.062,5.53,5.53,0,0,1-3.195-3.686,5.233,5.233,0,0,1,.619-4.289,5.752,5.752,0,0,1,3.829-2.67,5.556,5.556,0,0,1,.913-.12A5.787,5.787,0,0,1-360.054,2007.694Zm-.383,1.466a4.26,4.26,0,0,0-4.318,4.176,4.257,4.257,0,0,0,4.318,4.176,4.57,4.57,0,0,0,2.961-1.136,3.938,3.938,0,0,0,1.364-3.046A4.258,4.258,0,0,0-360.437,2009.16Z",
    transform: "translate(366.294 -2007.681)",
    fill: "#9ca4ba"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.352853b3e2093ab1e94cdf5e68545ae7.svg";
export { ForwardRef as ReactComponent };